import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTransition } from '../context/TransitionContext';

const NotFound = () => {
  const { startTransition } = useTransition();
  const { t } = useLanguage();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--v2-color-offwhite)',
      fontFamily: 'var(--v2-font-primary)'
    }}>
      <h1 style={{
        fontSize: 'clamp(100px, 20vw, 200px)',
        fontWeight: 700,
        color: 'var(--v2-color-charcoal)',
        margin: 0,
        lineHeight: 1
      }}>
        404
      </h1>
      <p style={{
        fontSize: '18px',
        color: 'var(--v2-color-taupe)',
        margin: '24px 0 48px'
      }}>
        {t('common.pageNotFound')}
      </p>
      <button
        onClick={() => startTransition('/')}
        style={{
          padding: '16px 32px',
          backgroundColor: 'var(--v2-color-charcoal)',
          color: 'white',
          border: 'none',
          borderRadius: '100px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
      >
        {t('common.backToHome')}
      </button>
    </div>
  );
};

export default NotFound;
